<script>
import { chartHelpers } from "./Charts";
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  data () {
    return {
      cData: this.data
    };
  },
  computed: {
    mergedData: function () {
      return chartHelpers.mergeColorsIntoPieData(this.cData);
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { 
        return {
          labels: ["A","B","C","D"],
          datasets:[
            {borderWidth:0,data:[1,2,3,4]},
            {borderWidth:0,data:[10,2,1,9]}
          ]
        };
      }
    },
    options: {
      type: Object,
      default: () => { 
        return {
          responsive: true, 
          maintainAspectRatio: false, 
          rotation:(-1 * Math.PI), 
          cutoutPercentage: 80, 
          legend:{display: false}
        };
      }
    }
  },
  mounted () {
      this.renderChart(this.mergedData, this.options);
  },
  watch: {
    'cData.datasets': {
      handler: () => {
        this.renderChart(this.mergedData, this.options);
      }
    },
    deep: true
  }
};
</script>
